import { createSelector, MemoizedSelector } from '@ngrx/store';
import { ErrorStore, Notification } from '@sleipai/sleip-models';

import {
  selectAllNotificationsForRecordingsUnreadAdapter,
  selectNotificationsForRecordingsUnreadIdsAdapter,
  NotificationsForRecordingsUnreadState,
} from '../entity/notifications-for-recordings-unread.entity';
import { State } from '../reducers/notification.reducer';
import { selectNotificationsState } from './notification.selectors';

export const notificationsForRecordingsUnreadSlice = (
  state: State
): NotificationsForRecordingsUnreadState => state.notificationsForRecordingsUnread;
export const isNotificationsForRecordingsUnreadLoading = (state: State): boolean =>
  state.notificationsForRecordingsUnreadLoading;
export const isNotificationsForRecordingsUnreadLoaded = (state: State): boolean =>
  state.notificationsForRecordingsUnreadLoaded;
export const notificationsForRecordingsUnreadError = (state: State): ErrorStore | null =>
  state.notificationsForRecordingsUnreadError;

const selectNotificationsForRecordingsUnreadSlice = createSelector(
  selectNotificationsState,
  notificationsForRecordingsUnreadSlice
);

export const selectAllNotificationsForRecordingsUnread: MemoizedSelector<
  object,
  Notification[]
> = createSelector(
  selectNotificationsForRecordingsUnreadSlice,
  selectAllNotificationsForRecordingsUnreadAdapter
);

export const selectIsNotificationsForRecordingsUnreadLoading: MemoizedSelector<object, boolean> =
  createSelector(selectNotificationsState, isNotificationsForRecordingsUnreadLoading);

export const selectIsNotificationsForRecordingsUnreadLoaded: MemoizedSelector<object, boolean> =
  createSelector(selectNotificationsState, isNotificationsForRecordingsUnreadLoaded);

export const selectNotificationsForRecordingsUnreadError: MemoizedSelector<
  object,
  ErrorStore | null
> = createSelector(selectNotificationsState, notificationsForRecordingsUnreadError);

export const selectNotificationsForRecordingsUnreadIds: MemoizedSelector<
  object,
  Record<string, boolean>
> = createSelector(
  createSelector(
    selectNotificationsForRecordingsUnreadSlice,
    selectNotificationsForRecordingsUnreadIdsAdapter
  ),
  (recordingIds) =>
    (recordingIds as string[]).reduce((unread, recordingId) => {
      unread[recordingId] = true;
      return unread;
    }, {} as Record<string, boolean>)
);
